
export class MarkPlanGoodsModel {
  /**
   * Ｐコード共通
   */
  // 受注コード
  public orderCode: string = <string>'';
  // Ｐコード
  public pCode: string = <string>'';

  /**
   * Ｐコード詳細情報
   */
  // 商品台帳マークコード
  public goodsMarkCode: string = <string>'';
  // 商品台帳マーク
  public goodsMark: string = <string>'';
}
